import renderMathInElement from 'katex/dist/contrib/auto-render.js';
import 'katex/dist/katex.min.css';

/**
 * Funcion para renderizar el KaTeX en un elemento HTML
 * @param {HTMLElement} htmlElement - El elemento HTML en el que se renderizará el KaTeX
 * @returns {void}
 */

export const KATEX_DELIMITERS = [
  { left: '$$', right: '$$', display: true },
  { left: '$', right: '$', display: false },
  { left: '\\[', right: '\\]', display: true },
  { left: '\\(', right: '\\)', display: false },
];

export function renderKatexInElement(htmlElement) {
  if (!htmlElement) return;
  try {
    renderMathInElement(htmlElement, {
      delimiters: KATEX_DELIMITERS,
      throwOnError: false,
    });
  } catch (e) {
    console.warn('KaTeX:', e);
  }
}

export function attachKatexToSurveyModel(model) {
  model.onAfterRenderQuestion.add((sender, options) => {
    renderKatexInElement(options.htmlElement);
  });
  model.onAfterRenderPage.add((sender, options) => {
    renderKatexInElement(options.htmlElement);
  });
}
